import { AUTO_LAUNCH_RULES } from "../../config/gameplay";
import { nonNegative } from "../../utils/math";
import { createDefaultAutoLaunchState } from "./defaults";
import type { AutoLaunchState, AutoLaunchTicketSeconds } from "./types";

export function sanitizeAutoLaunch(raw: unknown): AutoLaunchState {
  const defaults = createDefaultAutoLaunchState();
  if (!isRecord(raw)) {
    return defaults;
  }

  const activeTicketSeconds = sanitizeTicketSeconds(raw.activeTicketSeconds);
  const activeRemainingSeconds = activeTicketSeconds ? nonNegative(raw.activeRemainingSeconds) : 0;
  return {
    activeTicketSeconds,
    activeRemainingSeconds,
    autoExtendEnabled: raw.autoExtendEnabled === true,
    spawnBudget: Math.min(AUTO_LAUNCH_RULES.spawnBudgetCap, nonNegative(raw.spawnBudget))
  };
}

function sanitizeTicketSeconds(value: unknown): AutoLaunchTicketSeconds | null {
  return value === 60 || value === 120 || value === 300 || value === 600 ? value : null;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
